/* derived from Autosuggest script by Timothy Groves - http://www.brandspankingnew.net */

if (typeof(C3Search) == "undefined")
	_C3S = C3Search = {};

if (typeof(_C3S.autoSuggest) == "undefined")
{ _C3S.autoSuggest = {}; }
else
{
	cyclone3.log("autoSuggest already defined");
}

_C3S.autoSuggest = function (fieldId, config, parentId)
{
	if (!document.getElementById)
	{
		return 0;
	}

	this.inputField = _C3S.DOM.gE(fieldId);

	if (!this.inputField)
	{
		return 0;
	}

	this.sInp		= "";
	this.nInpC		= 0;
	this.iHigh		= 0;
	this.parentId = parentId || "search-wrapper";

	// config object

	this.config = config ? config : {};

	// defaults

	var k, def = {
		minchars:			3,				//min search term length
		meth:				"get",			//form method
		varname:			"q",			//variable name - sent after hitting enter
		width: 				'auto',			//popup height
		className:			"dropdown-menu autosuggest",		//popup class
		anchorPoint:		'bottomLeft',	//popup anchor point
		offsety:			-5,				//vertical offset
		
		clearTimeout: 		300000,			//autohide timeout
		delay:				100,			//
		shownoresults:		true,			//show 'no results' notice when no results are found
		labelNoresults: 	"Nenašli sa žiadne zodpovedajúce výsledky",	//'no results' notice caption
		labelShowall:		"Všetky výsledky v produktoch ",		//'show all' button caption
		
		id:					fieldId,		//id of popup
		loader:				false,			//create/show loader
		cleaner:			false,			//create/show cleaner button
	};
	for (k in def)
	{
		if (typeof(this.config[k]) != typeof(def[k]))
		{
			this.config[k] = def[k];
		}
	}
	
	var p = this;
	
	var pos = _C3S.DOM.getPos(this.inputField);
	
	if(this.config.loader)
	{
		cyclone3.log('creating loader element ' + this.config.id + '-loader');
		this.loader = _C3S.DOM.cE(
			"span",
			{
				'id': this.config.id+'-loader'
			}
		);
		this.loader.style.left		= pos.x + this.inputField.offsetWidth + "px";
		this.loader.style.top		= pos.y + "px";
		
		this.loader = document.getElementsByTagName("body")[0].appendChild(this.loader);
	}
	
	if(this.config.cleaner)
	{
		cyclone3.log('creating cleaner element ' + this.config.id + '-cleaner');
		this.cleaner = _C3S.DOM.cE(
			"span",
			{
				'id': this.config.id+'-cleaner'
			}
		);
		this.cleaner.style.left		= pos.x + this.inputField.offsetWidth + "px";
		this.cleaner.style.top		= pos.y + "px";
		
		this.cleaner.onclick = function () {
			p.clearSuggestions();
			this.style.display="none";
			p.inputField.value='';
			p.focus();
			return false;
		};
		
		this.cleaner = document.getElementsByTagName("body")[0].appendChild(this.cleaner);
	}
	
	// set keyup handler for field
	// and prevent autocomplete from client
	
	// NOTE: not using addEventListener because UpArrow fired twice in Safari
	//_C3S.DOM.addEvent( this.inputField, 'keyup', function(ev){ return pointer.onKeyPress(ev); } );
	
	this.inputField.onkeypress = function(ev){
		return p.onKeyPress(ev);
	};
	this.inputField.onkeyup = function(ev) {
		return p.onKeyUp(ev);
	};
	
	this.inputField.setAttribute("autocomplete", "off");
};

_C3S.autoSuggest.prototype.onKeyPress = function(ev)
{
	var key = (window.event) ? window.event.keyCode : ev.keyCode;

	var RETURN = 13;	// open selected item
	var ESC = 27;		// ESCAPE clears the list

	var bubble = 1;

	switch(key)
	{
		case RETURN:
			this.setHighlightedValue();
			bubble = 0;
			cyclone3.cancelEvent(ev);
			break;
		case ESC:
			this.clearNotices();
			this.clearSuggestions();
			break;
	}
	
	return bubble;
};

_C3S.autoSuggest.prototype.onKeyUp = function(ev)
{
	var key = (window.event) ? window.event.keyCode : ev.keyCode;
	
	var ARRUP = 38;
	var ARRDN = 40;
	
	var bubble = 1;
	
	switch(key)
	{
		case ARRUP:
			this.changeHighlight(key);
			bubble = 0;
			break;
		case ARRDN:
			this.changeHighlight(key);
			bubble = 0;
			break;
		default:
			this.getSuggestions(this.inputField.value);
			if(typeof this.cleaner != 'undefined')
			{
				if(this.inputField.value)
				{
					this.reAnchorIndicators(this);
					this.cleaner.style.display = "block";
				}else{
					this.cleaner.style.display = "none";
				}
			}
	}
	
	return bubble;
};

_C3S.autoSuggest.prototype.getSuggestions = function (val, force)
{
	// if input stays the same, do nothing
	if (val == this.sInp)
	{
		// redo the request if forced. other search params might have changed
		if (!force)
		{
			return 0;
		}
	}
	
	// clear popup
	this.clearNotices(this.idNotice);
	_C3S.DOM.eE(this.idList);
	
	this.sInp = val;
	
	// input length is less than the min required to trigger a request
	// do nothing
	//
	if (val.length < this.config.minchars)
	{
		this.nInpC = val.length;
		return 0;
	}
	
	this.nInpC = val.length ? val.length : 0;
	
	var pointer = this;
	var input = this.sInp;
	
	clearTimeout(this.ajID);
	
	this.ajID = setTimeout(
		function() {
			pointer.doAjaxRequest(input);
		},
		this.config.delay
	);
	
	return false;
};

_C3S.autoSuggest.prototype.doAjaxRequest = function (input)
{
	// check that saved input is still the value of the field
	//
	if (input != this.inputField.value)
		return false;
	
	var pointer = this;
	
	var url;
	
	if (typeof(this.config.script) == "function")
	{
		url = this.config.script(encodeURIComponent(this.sInp));
	}
	else
	{
		url = this.config.script + this.config.varname + "=" + encodeURIComponent(this.sInp);
	}
	
	if (!url)
		return false;
	
	var meth = this.config.meth;
	var inputElem = this.sInp;
	
	var onSuccessFunc = function (req) {
		pointer.setSuggestions(req, inputElem);
	};
	var onErrorFunc = function (status) {
		cyclone3.log("AJAX error: "+status);
	};
	
	var myAjax = new _C3S.Ajax();
	myAjax.makeRequest( url, meth, onSuccessFunc, onErrorFunc );
	
	this.reAnchorIndicators(this);
	
	if(typeof this.loader != 'undefined')
	{
		this.loader.style.display="block";
	}
};

_C3S.autoSuggest.prototype.setSuggestions = function (req, input)
{
	if(typeof this.loader != 'undefined')
	{
		this.loader.style.display="none";
	}

	// if field input no longer matches what was passed to the request
	// don't show the suggestions
	//
	if (input != this.inputField.value)
		return false;

	this.idPopup = "c3s_"+this.config.id;
	this.idList = "c3s_list_"+this.config.id;
	this.idNotice = "c3s_notice_"+this.config.id;

	if (this.config.json)
	{
		var jsondata = JSON.parse(req.responseText);

		this.JSONCreateList(jsondata);
	}
	else
	{
		var xml = req.responseXML;
		
		this.XMLcreateList(xml);
	}
};

_C3S.autoSuggest.prototype.reAnchorIndicators = function(c3sInstance)
{
	// get position of target textfield
	// position holding div below it
	// set width of holding div to width of field
	//
	var pos = _C3S.DOM.getPos(c3sInstance.inputField);
	
	switch (c3sInstance.config.anchorPoint)
	{
		case 'bottomLeft':
			//c3sInstance.resultsDiv.style.left	= pos.x + "px";
			//c3sInstance.resultsDiv.style.top	= ( pos.y + c3sInstance.inputField.offsetHeight + c3sInstance.config.offsety ) + "px";
			break;
		case 'bottomRight':
			//c3sInstance.resultsDiv.style.left	= pos.x + c3sInstance.inputField.offsetWidth - c3sInstance.config.width + "px";
			//c3sInstance.resultsDiv.style.top	= ( pos.y + c3sInstance.inputField.offsetHeight + c3sInstance.config.offsety ) + "px";
			if(typeof c3sInstance.loader != 'undefined')
			{
				c3sInstance.loader.style.left	= pos.x + c3sInstance.inputField.offsetWidth + "px";
				c3sInstance.loader.style.top	= ( pos.y + c3sInstance.inputField.offsetHeight + c3sInstance.config.offsety ) + "px";
			}
			if(typeof c3sInstance.cleaner != 'undefined')
			{
				c3sInstance.cleaner.style.left	= pos.x + c3sInstance.inputField.offsetWidth + "px";
				c3sInstance.cleaner.style.top	= ( pos.y + c3sInstance.inputField.offsetHeight + c3sInstance.config.offsety ) + "px";
			}
			break;
		default:
			break;
	}
}

_C3S.autoSuggest.prototype.anchorResults = function(c3sInstance)
{
		// get position of target textfield
		// position holding div below it
		// set width of holding div to width of field
		//
		var pos = _C3S.DOM.getPos(c3sInstance.inputField);
		
		switch (c3sInstance.config.anchorPoint)
		{
			case 'bottomLeft':
				// c3sInstance.resultsDiv.style.left	= pos.x + "px";
				// c3sInstance.resultsDiv.style.top	= ( pos.y + c3sInstance.inputField.offsetHeight + c3sInstance.config.offsety ) + "px";
				break;
			case 'bottomRight':
				c3sInstance.resultsDiv.style.left	= pos.x + c3sInstance.inputField.offsetWidth - c3sInstance.config.width + "px";
				c3sInstance.resultsDiv.style.top	= ( pos.y + c3sInstance.inputField.offsetHeight + c3sInstance.config.offsety ) + "px";
				break;
			default:
				break;
		}
		
		// if(c3sInstance.config.width!='auto')
		// {
		// 	c3sInstance.resultsDiv.style.width = c3sInstance.config.width + "px";
		// }
		// else
		// {
		// 	c3sInstance.resultsDiv.style.width = c3sInstance.inputField.offsetWidth + "px";
		// }
		
		// set mouseover functions for div
		// when mouse pointer leaves div, set a timeout to remove the list after an interval
		// when mouse enters div, kill the timeout so the list won't be removed
		//
		c3sInstance.resultsDiv.onmouseover	= function(){
			c3sInstance.killTimeout();
		};
		c3sInstance.resultsDiv.onmouseout	= function(){
			c3sInstance.resetTimeout();
		};
		
		// currently no item is highlighted
		//
		c3sInstance.iHigh = 0;
		
		// remove list after an interval
		//
		c3sInstance.toID = setTimeout(
			function () {
				c3sInstance.clearNotices();
				c3sInstance.clearSuggestions();
			},
			c3sInstance.config.clearTimeout
		);
}

_C3S.autoSuggest.prototype.JSONCreateList = function(jsonResults)
{
	try
	{
		var pointer = this;
		var showAll = 0;
		
		// get rid of old list
		// and clear the list removal timeout
		
		this.clearNotices();
		_C3S.DOM.eE(this.idList);
		this.killTimeout();

		// if no results, and shownoresults is false, do nothing
		
		if (jsonResults.total == 0 && !this.config.shownoresults)
		{
			cyclone3.log('shownoresults not on, exiting...');
			return false;
		}
		
		if(!this.resultsDiv)
		{
			this.resultsDiv = document.getElementById(this.parentId).appendChild(
				_C3S.DOM.cE(
					"div",
					{
						id:this.idPopup,
						className:this.config.className
					}
				)
			);
			this.resultsList = this.resultsDiv.appendChild(
				_C3S.DOM.cE(
					"ul",
					{
						id: this.idList,
						className:"autosuggest__list"
					}
				)
			);
		}
		else
		{
			this.resultsDiv.style.opacity=1;
		}
		
		if (jsonResults.total == 0)
		{
			if(!_C3S.DOM.gE(this.idNotice))
			{
				this.resultsDiv.appendChild(
					_C3S.DOM.cE(
						"h4",
						{
							id: this.idNotice,
							className:"autosuggest__header"
						},
						this.config.labelNoresults
					)
				);
			}
		}
		else{
			_C3S.DOM.remE(_C3S.DOM.gE(this.idNotice));
		}
		
		var highlighterCounter=1;
		
		for (var blockId in jsonResults.blocks)
		{
			var block = jsonResults.blocks[blockId];
			
			var tmpSection = _C3S.DOM.cE(
				"h4",
				{
					className: 'autosuggest__header'
				},
				block.title,
				true
			);
			
			tmpSection.dataset.ordinal = highlighterCounter;
			highlighterCounter++;
			
			this.resultsList.appendChild(tmpSection);
			
			if (block.more)
			{
				showAll = 0;
			}
			
			//cyclone3.log(block.hits);
			
			var tmpList = this.resultsList;
			
			block.hits.forEach(
				function (item, index, array)
				{
					// item.namePlain = $('<li></li>').append(item.name).text();
					
					switch (blockId)
					{
						case 'product':
							//itemDescription =
							//	"<span class='price'>"
							//	+ sectionitems[i].getElementsByTagName('price')[0].childNodes[0].nodeValue
							//	+ "</span>"
							//	+ sectionitems[i].getElementsByTagName('description')[0].childNodes[0].nodeValue;
							break;
						case 'product_brand':
							//itemDescription = sectionitems[i].getElementsByTagName('description')[0].childNodes[0].nodeValue;
							break;
						case 'product_category':
							//itemDescription = sectionitems[i].getElementsByTagName('description')[0].childNodes[0].nodeValue;
							break;
						default:
							break;
					}
					
					var tmpItem = _C3S.DOM.cE(
						"a",
						{
							href: item.uri
						}
					);
					
					if(blockId.match(/_series$/))
					{
						tmpItem.className = tmpItem.className + ' series';
					}
					
					if(item.air_start)
					{
						tmpItem.className = tmpItem.className + ' dated';
						
						tmpItem.appendChild(
							_C3S.DOM.cE(
								"span",
								{
									className: 'c3s_datetime'
								},
								item.air_start_p,
								true
							)
						);
					}
					
					var tmpItemThumb = _C3S.DOM.cE(
						"span",
						{
							className: 'autosuggest__img'
						}
					);
					if (item.thumbnail)
					{
						tmpItemThumb.appendChild(
							_C3S.DOM.cE(
								"img",
								{
									src: item.thumbnail
								}
							)
						);
					}
					tmpItem.appendChild(tmpItemThumb);
					show_name = item.name;
					if (item.name_hl) {
						show_name = item.name_hl;	
					}
					tmpItem.appendChild(
						_C3S.DOM.cE(
							"span",
							{
								className: 'c3s_name'
							},
							
							show_name.replace(/&lt;/g, '<').replace(/&gt;/g, '>'),
							true
						)
					);
					
					if(item.description)
					{
						tmpItem.appendChild(
							_C3S.DOM.cE(
								"span",
								{
									className: 'c3s_desc'
								},
								item.description.replace(/&lt;/g, '<').replace(/&gt;/g, '>'),
								true
							)
						);
					}
					
					tmpItem.dataset.ordinal = highlighterCounter;
					highlighterCounter++;
					
					tmpItem.onmouseover = function () {
						pointer.setHighlight(this.dataset.ordinal);
					};
					
					tmpList.appendChild(tmpItem);
				}
			)
		}
		
		if(this.config.labelShowall && jsonResults.blocks.products.more == 1)
		{
			var tmpSearchField = this.inputField;
			var tmpShowAll = _C3S.DOM.cE(
				"a",
				{
					id: this.idNotice,
					className: 'autosuggest__footer',
					href: cyclone3.domain + "/search?q=" + pointer.inputField.value
				},
				this.config.labelShowall + ' (' + jsonResults.total + ')',
				true
			);
			tmpShowAll.dataset.ordinal = highlighterCounter;
			highlighterCounter++;
			
			tmpShowAll.onclick = function (evt)
			{
				cyclone3.cancelEvent(evt);
				$(tmpSearchField).closest('form').submit();
			};
			tmpShowAll.onmouseover = function ()
			{
				pointer.setHighlight(this.dataset.ordinal);
			};
			
			this.resultsDiv.appendChild(
				tmpShowAll
			);
		}
		
		this.anchorResults(this);
	}
	catch(e)
	{
		cyclone3.log(e);
	}
};

_C3S.autoSuggest.prototype.XMLCreateList = function(xmlResults)
{
	try
	{
		cyclone3.log('xml processing needs derivation from JSONCreateList');
	}
	catch(e)
	{
		cyclone3.log(e);
	}
}

/* hovers */

_C3S.autoSuggest.prototype.changeHighlight = function(key)
{
	var list = _C3S.DOM.gE(this.idList);
	if (!list.hasChildNodes())
	{
		return false;
	}
	
	var n;
	var showAll = _C3S.DOM.gE(this.idNotice);
	
	if (key == 40)
	{
		n = this.iHigh + 1;
		cyclone3.log('stepping down to ' + n);
		if(typeof list.childNodes[n-1] != 'undefined')
		{
			//skip section
			if(list.childNodes[n-1].className.match(/section/))
			{
				n++;
				cyclone3.log('  this is section, step down to ' + n);
			}
		}
		else
		{
			if(showAll)
			{
				cyclone3.log('  no more results, highlighting Show All');
			}
		}
	}
	else if (key == 38)
	{
		n = this.iHigh - 1;
		cyclone3.log('stepping up to ' + n);
		if(typeof list.childNodes[n-1] != 'undefined')
		{
			//skip section
			if(list.childNodes[n-1].className.match(/section/))
			{
				n--;
				cyclone3.log('  this is section, step up to ' + n);
			}
		}
	}
	
	cyclone3.log('checking if ' + n + '>' + list.childNodes.length + ' showAll: ' + showAll);
	
	if (n > list.childNodes.length)
	{
		if(showAll)
		{
			n = list.childNodes.length + 1;
			//cyclone3.log('show all exists, set n to ' + n);
		}
		else
		{
			n = list.childNodes.length;
			//cyclone3.log('show all doesn\'t exist, set n to ' + n);
		}
	}
	
	if (n < 1)
	{
		n = 1;
	}
	
	this.setHighlight(n);
};

_C3S.autoSuggest.prototype.setHighlight = function(n)
{
	var list = _C3S.DOM.gE(this.idList);
	if (!list)
		return false;
	
	var showAll = _C3S.DOM.gE(this.idNotice);
		
	if (this.iHigh > 0)
		this.clearHighlight();

	this.iHigh = Number(n);
	
	cyclone3.log('node count ' + list.childNodes.length + ' ihigh ' + this.iHigh + ' checking node ' + list.childNodes[this.iHigh-1]);
	
	if (list.childNodes[this.iHigh-1])
	{
		list.childNodes[this.iHigh-1].className = list.childNodes[this.iHigh-1].className + " hl";
	}
	else
	{
		if (showAll)
		{
			showAll.className = showAll.className + ' hl';
		}
	}

	this.killTimeout();
};

_C3S.autoSuggest.prototype.clearHighlight = function()
{
	var list = _C3S.DOM.gE(this.idList);
	if (!list)
		return false;

	if (this.iHigh > 0)
	{
		if (this.iHigh > list.childNodes.length)
		{
			var showAll = _C3S.DOM.gE(this.idNotice);
			showAll.className = showAll.className.replace(' hl', '');
		}
		if(typeof list.childNodes[this.iHigh-1] != 'undefined')
		{
			list.childNodes[this.iHigh-1].className = list.childNodes[this.iHigh-1].className.replace(' hl', '');
		}
		this.iHigh = 0;
	}
};

_C3S.autoSuggest.prototype.setHighlightedValue = function ()
{
	if (this.iHigh)
	{
		var list = _C3S.DOM.gE(this.idList);
		
		if(this.iHigh > list.childNodes.length)
		{
			var showAll = _C3S.DOM.gE(this.idNotice);
			if(showAll)
			{
				document.location.href = showAll.getAttribute('href');
			}
		}
		else
		{
			var tmpItem = list.childNodes[this.iHigh-1];
			
			if(tmpItem)
			{
				if(tmpItem.className.match(/c3s_suggest/))
				{
					this.inputField.focus();
					if (this.inputField.selectionStart)
						this.inputField.setSelectionRange(this.sInp.length, this.sInp.length);
					
					this.clearNotices();
					this.clearSuggestions();
				}
				else if(tmpItem.className.match(/c3s_item/))
				{
					window.location.href=tmpItem.getAttribute('href');
				}
			}
		}
	}
	else
	{
		$(this.inputField).closest('form').submit();
	}
};

/* timeouts */

_C3S.autoSuggest.prototype.killTimeout = function()
{
	clearTimeout(this.toID);
};

_C3S.autoSuggest.prototype.resetTimeout = function()
{
	clearTimeout(this.toID);
	var pointer = this;
	this.toID = setTimeout(
		function () {
			pointer.clearNotices();
			pointer.clearSuggestions();
		},
		1000
	);
};

/* cleanup */

_C3S.autoSuggest.prototype.clearNotices = function ()
{
	//cyclone3.log('clearing notices');
	_C3S.DOM.remE(_C3S.DOM.gE(this.idNotice));	
};

_C3S.autoSuggest.prototype.clearSuggestions = function ()
{

	this.killTimeout();

	var ele = _C3S.DOM.gE(this.idPopup);
	var pointer = this;
	if (ele)
	{
		new _C3S.Fader(
			ele,
			1,0,
			250,
			function () {
				_C3S.DOM.eE(pointer.idList);
			}
		);
	}
};

/* AJAX */

if (typeof(_C3S.Ajax) == "undefined")
	_C3S.Ajax = {};

_C3S.Ajax = function ()
{
	this.req = {};
	this.isIE = false;
};

_C3S.Ajax.prototype.makeRequest = function (url, meth, onComp, onErr)
{

	if (meth != "POST")
		meth = "GET";

	this.onComplete = onComp;
	this.onError = onErr;

	var pointer = this;

	// branch for native XMLHttpRequest object
	if (window.XMLHttpRequest)
	{
		this.req = new XMLHttpRequest();
		this.req.onreadystatechange = function () { pointer.processReqChange() };
		this.req.open("GET", url, true); //
		this.req.send(null);
	}
	// branch for IE/Windows ActiveX version
	else if (window.ActiveXObject)
	{
		this.req = new ActiveXObject("Microsoft.XMLHTTP");
		if (this.req)
		{
			this.req.onreadystatechange = function () {
				pointer.processReqChange();
			};
			this.req.open(meth, url, true);
			this.req.send();
		}
	}
};

_C3S.Ajax.prototype.processReqChange = function()
{
	if (this.req.readyState == 4) {
		if (this.req.status == 200)
		{
			this.onComplete( this.req );
		} else {
			this.onError( this.req.status );
		}
	}
};

/* DOM */

if (typeof(_C3S.DOM) == "undefined")
	_C3S.DOM = {};

_C3S.DOM.cE = function ( type, attr, cont, html )
{
	var ne = document.createElement( type );
	if (!ne)
		return 0;

	for (var a in attr)
		ne[a] = attr[a];

	var t = typeof(cont);

	if (t == "string" && !html)
		ne.appendChild( document.createTextNode(cont) );
	else if (t == "string" && html)
		ne.innerHTML = cont;
	else if (t == "object")
		ne.appendChild( cont );
	
	return ne;
};

_C3S.DOM.gE = function ( e )
{
	var t=typeof(e);
	if (t == "undefined")
		return 0;
	else if (t == "string")
	{
		var re = document.getElementById( e );
		if (!re)
			return 0;
		else if (typeof(re.appendChild) != "undefined" )
			return re;
		else
			return 0;
	}
	else if (typeof(e.appendChild) != "undefined")
		return e;
	else
		return 0;
};

_C3S.DOM.eE = function ( ele )
{
	var e = this.gE(ele);
	
	if (!e)
	{
		return 0;
	}
	else
	{
		while (e.hasChildNodes()) {
			e.removeChild(e.lastChild);
		}
		return true;
	}
};

_C3S.DOM.remE = function ( ele )
{
	var e = this.gE(ele);
	
	if (!e)
		return 0;
	else if (e.parentNode.removeChild(e))
		return true;
	else
		return 0;
};

_C3S.DOM.getPos = function (e)
{
	e = this.gE(e);
	
	var obj = e;
	
	var curleft = 0;
	if (obj.offsetParent)
	{
		while (obj.offsetParent)
		{
			curleft += obj.offsetLeft;
			obj = obj.offsetParent;
		}
	}
	else if (obj.x)
		curleft += obj.x;
	
	obj = e;
	
	var curtop = 0;
	if (obj.offsetParent)
	{
		while (obj.offsetParent)
		{
			curtop += obj.offsetTop;
			obj = obj.offsetParent;
		}
	}
	else if (obj.y)
		curtop += obj.y;

	return {x:curleft, y:curtop};
};

/* fader */

if (typeof(_C3S.Fader) == "undefined")
	_C3S.Fader = {};

_C3S.Fader = function (ele, from, to, fadetime, callback)
{
	if (!ele)
		return 0;

	this.e = ele;

	this.from = from;
	this.to = to;

	this.cb = callback;

	this.nDur = fadetime;

	this.nInt = 50;
	this.nTime = 0;

	var p = this;
	this.nID = setInterval(function() { p._fade() }, this.nInt);
};

_C3S.Fader.prototype._fade = function()
{
	this.nTime += this.nInt;
	
	var ieop = Math.round(
		this._tween(
			this.nTime,
			this.from,
			this.to,
			this.nDur
		) * 100
	);
	var op = ieop / 100;
	
	if (this.e.filters) // internet explorer
	{
		try
		{
			this.e.filters.item("DXImageTransform.Microsoft.Alpha").opacity = ieop;
		} catch (e) {
			// If it is not set initially, the browser will throw an error.  This will set it if it is not set yet.
			this.e.style.filter = 'progid:DXImageTransform.Microsoft.Alpha(opacity='+ieop+')';
		}
	}
	else // other browsers
	{
		this.e.style.opacity = op;
	}
	
	if (this.nTime == this.nDur)
	{
		clearInterval( this.nID );
		if (this.cb !== undefined)
			this.cb();
	}
};

_C3S.Fader.prototype._tween = function(t,b,c,d)
{
	return b + ( (c-b) * (t/d) );
};
